import React from 'react';
import { CtaButton } from './CtaButton';
type CtaBlockProps = {
  headline: string;
  label?: string;
  showTimer?: boolean;
  className?: string;
};

/**
 * Transformational CTA placed at the end of each section:
 * a benefit statement plus the buy button.
 */
export function CtaBlock({
  headline,
  label = 'I want the Master Welding System',
  className = ''
}: CtaBlockProps) {
  return <div className={`mx-auto w-full max-w-xl ${className}`} data-id="element-26" data-mp="1zpkjzytlrli3">
      <p className="mb-3 text-center font-display text-lg font-bold uppercase leading-tight text-white sm:text-xl" data-id="element-27" data-mp="1znzn42jtfqh2">
        {headline}
      </p>
      <CtaButton label={label} sublabel="One-time payment · Instant access" data-id="element-28" data-mp="1qq5ub1l9feyn" />
    </div>;
}